module.exports = __webpack_public_path__ + "static/businessCardsMobile@2x-ea6c554f1c1a49389dfe03d7a30be875.png";